<div class="recommend">
  <div class="recommend__title">
    <div class="title-header">Customer reviews</div>
    <!-- <div class="add" id="add-experience-btn" *ngIf="isLogin == 1" (click)="openRecommendationModal(recomendationPopup)">
      Add <i class="fa-solid fa-arrow-alt-circle-down"></i>
    </div> -->
    <div class="d-flex">
      <button *ngIf="!isLogin && showAddBtn" class="my-button-3 mr-2" (click)="addClicked()">+</button>
      <div style="cursor: pointer" (click)="viewRecommend = !viewRecommend">
        @if(!viewRecommend){
        <i class="fa-solid fa-grip-vertical"></i>
        }@else{
        <i class="fa-solid fa-list"></i>
        }
      </div>
    </div>
  </div>
  <!-- <div *ngIf="productSuggestions?.data && productSuggestions.data?.length < 1">
    <div class="alert alert-secondary text-center" role="alert"><i class="fa-regular fa-comment-alt"></i> There are no
      Experiences at this time</div>
  </div> -->
  <!-- <button class="btn btn-sm btn-purple float-btn" (click)="openRecommendationModal(recomendationPopup)"><i class="fa-solid fa-plus"></i> ADD</button> -->
  <div class="suggestion-grid-container" [class.list]="!viewRecommend" *ngIf="productSuggestions?.data">
    @if(viewRecommend){
    <ng-container *ngFor="let iframeSrc of youtubeIframes">
      <div class="card-suggestion">
        <section>
          <div [innerHTML]="iframeSrc"></div>
        </section>
      </div>
    </ng-container>

    <ng-container *ngFor="let suggestion of productSuggestions.data">
      <div class="card-suggestion">
        <span *ngIf="suggestion.isPinned" style="position: absolute; top: 3; left: 3; color: var(--primary)">
          <i class="fa-solid fa-thumbtack sub-menu-icon" style="color: var(--primary)"></i>
        </span>
        <span *ngIf="suggestion.commentCount > 0" class="d-flex justify-content-end border px-2 py-0 bg-white comments">
          {{ suggestion.commentCount }}
          <i class="fa-regular fa-comments my-auto pl-1"></i>
        </span>
        <span *ngIf="suggestion.suggestionLikes?.length > 0" class="d-flex justify-content-end border px-2 py-0 bg-white likes" (click)="likeSuggestion(suggestion.id, suggestion)">
          {{ suggestion.suggestionLikes?.length }}
          <i class="fa-{{ hasChecked(suggestion.suggestionLikes) ? 'solid' : 'regular' }} fa-heart my-auto pl-1"></i>
        </span>

        <ng-container *ngIf="suggestion.recommendationType && (suggestion.recommendationType == 'video' || suggestion.recommendationType == 'youtube'); else RecommendImages">
          <section *ngIf="suggestion.recommendationType == 'youtube'">
            <span (click)="openSuggestionInModal(suggestion, view_recommendation_modal)" class="pl-1 yt-comments">
              <i class="fa fa-comments" aria-hidden="true"></i>
            </span>
            <iframe style="width: 100%; height: 200px" [src]="suggestion.image" frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </section>
          <section *ngIf="suggestion.recommendationType == 'video'" style="position: relative">
            <span class="pl-1" (click)="openSuggestionInModal(suggestion, view_recommendation_modal)">{{ suggestion.message | slice : 0 : 20 | titlecase }}</span>
            <video style="width: 100%; height: fit-content">
              <source [src]="imgUrl + suggestion.image" type="video/mp4" />
            </video>
            <button (click)="playVideo(imgUrl + suggestion.image)" class="my-button-3" style="position: absolute; bottom: 50%; left: 50%; transform: translate(-50%, 50%)"><i class="fa-solid fa-play"></i></button>
          </section>
        </ng-container>

        <ng-template #RecommendImages>
          <img loading="lazy" *ngIf="suggestion.image != ''" (click)="openSuggestionInModal(suggestion, view_recommendation_modal)" src="{{ imgUrl }}{{ suggestion.image }}" (error)="handleError($event)" class="pointer img-fluid img" alt="Icon 1 description" />
          <div *ngIf="suggestion.image == ''" (click)="openSuggestionInModal(suggestion, view_recommendation_modal)" class="my-auto text-center rounded-lg px-2 py-0 card-text h-100" style="background-color: #f6f6f6">
            <span class="text h-100" style="height: 200px !important"> "{{ suggestion.message.length > 80 ? suggestion.message.substr(0, 80) + "..." : suggestion.message }}" </span>
          </div>
        </ng-template>
      </div>
    </ng-container>
    <div class="card-suggestion add" id="add-experience-btn" *ngIf="isLogin == 1 && showAddBtn" (click)="openRecommendationModal(recomendationPopup)">
      <svg viewBox="0 0 600 600" fill="none">
        <path d="M33.3333 300H566.667M300 33.3334V566.667" stroke="var(--primary)" stroke-width="66.6667" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    }@else {
    <ng-container *ngFor="let suggestion of productSuggestions.data; index as i">
      <div class="card-suggestion">
        <span *ngIf="suggestion.isPinned" style="position: absolute; top: 3; left: 3; color: var(--primary)">
          <i class="fa-solid fa-thumbtack sub-menu-icon" style="color: var(--primary)"></i>
        </span>
        <div class="card-list-recommend">
          <div class="card-list-recommend__image" (click)="openSuggestionInModal(suggestion, view_recommendation_modal)">
            @if(suggestion.recommendationType == 'video'){
            <video>
              <source [src]="imgUrl + suggestion.image" type="video/mp4" />
            </video>
            }@else if(suggestion.recommendationType == 'youtube'){
            <iframe [src]="suggestion.image" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            }@else {
            <img loading="lazy" src="{{ imgUrl }}{{ suggestion.image }}" (error)="handleError($event)" alt="Icon 1 description" />

            }
          </div>
          <div>
            <div class="card-list-recommend__text" [class.line-break-5]="!showMessage[i]">"{{ suggestion.message.length > 80 ? suggestion.message + "..." : suggestion.message }}"</div>
            <div>
              <span *ngIf="suggestion.commentCount > 0" class="border px-2 py-0 bg-white">
                {{ suggestion.commentCount }}
                <i class="fa-regular fa-comments my-auto pl-1"></i>
              </span>
              <span *ngIf="suggestion.suggestionLikes?.length > 0" class="ml-2 px-2 py-0 bg-white" (click)="likeSuggestion(suggestion.id, suggestion)">
                {{ suggestion.suggestionLikes?.length }}
                <i class="fa-{{ hasChecked(suggestion.suggestionLikes) ? 'solid' : 'regular' }} fa-heart my-auto pl-1"></i>
              </span>
            </div>
            <div class="d-flex w-100 justify-content-center" *ngIf="suggestion.message.length >= 70">
              <button class="t-btn" style="top: 100%; left: 50%; color: var(--primary)" (click)="showMessage[i] = !showMessage[i]">
                Read More
                <i [class.fa-chevron-down]="!showMessage[i]" [class.fa-chevron-up]="showMessage[i]" class="fa-solid ml-1"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="card-suggestion add-list" id="add-experience-btn" *ngIf="isLogin == 1 && showAddBtn" (click)="openRecommendationModal(recomendationPopup)">
      <svg viewBox="0 0 600 600" fill="none">
        <path d="M33.3333 300H566.667M300 33.3334V566.667" stroke="var(--primary)" stroke-width="66.6667" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
    }
  </div>
  <!-- <div *ngIf="isLogin == 0">
      <div class="alert alert-danger" role="alert">
        <div class="d-flex flex-column flex-md-row justify-content-between">
          <span class="my-auto"> <i class="fa-solid fa-exclamation-circle"></i> Please log in first if you want to add recommendation </span>
          <button class="btn btn-sm btn-primary" (click)="loginHere()">Login Here !</button>
        </div>
      </div>
    </div> -->
</div>
<ng-template #view_recommendation_modal let-modal>
  <div class="bottom-sheet-recomendation">
    <div class="my-modal__close" (click)="closeModalByRef()">
      <i class="fa-solid fa-times"></i>
      <i class="fa-solid fa-angle-down"></i>
    </div>
    <div class="recommendation-modal__header">
      <h2 class="title">Experiences</h2>
      <div class="options">
        <div class="heart" (click)="likeSuggestion(selectedRecommendation.id, selectedRecommendation)">
          {{ selectedRecommendation.suggestionLikes?.length }}
          <i class="fa-{{ hasChecked(selectedRecommendation.suggestionLikes) ? 'solid' : 'regular' }} fa-heart"></i>
        </div>
        <div class="list" aria-hidden="true" id="recommendationMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fa-solid fa-ellipsis-v"></i>
        </div>
        <div class="dropdown-menu" aria-labelledby="recommendationMenu">
          <button class="dropdown-item" (click)="handlePin()"><i class="fa-solid fa-thumbtack sub-menu-icon"></i>{{ selectedRecommendation.isPinned ? "Unpin" : "Pin" }}</button>
          <button class="dropdown-item" (click)="openReportModal(reportsPopup, 'Recommendation')"><i class="fa-solid fa-flag sub-menu-icon"></i>Report</button>
          <button class="dropdown-item" (click)="openSuggestModal(suggestionsPopup, 'Recommendation')"><i class="fa-solid fa-pen-square sub-menu-icon"></i>Suggestion</button>
          <button class="dropdown-item" (click)="deleteSuggestion(selectedRecommendation.id)"><i class="fa-solid fa-trash sub-menu-icon"></i>Delete</button>
        </div>
      </div>
    </div>
    <div class="my-modal__body">
      <div class="content">
        <p [class.active]="recommendationSeeMore" #recommendation_content>"{{ selectedRecommendation.message }}"</p>
        @if(showSeeMore){
        <button class="scroll-arrow" (click)="recommendationSeeMore = !recommendationSeeMore">
          See More
          <i [class.down]="!recommendationSeeMore" class="fa-solid fa-chevron-up"></i>
        </button>
        }

        <img loading="lazy" src="{{ imgUrl }}{{ selectedRecommendation.image }}" alt="" />
      </div>

      <div>
        <div class="border-bottom p-1"><i class="fa-solid fa-comments"></i> Comments</div>
        <div class="card text-left p-0 mt-2 rounded-lg" *ngFor="let item of selectedRecommendation.comments">
          <div class="card-header bg-white border-0 p-0 px-1 pt-1 pb-0 mb-0 d-flex justify-content-between">
            <span class="mb-auto">{{ item.phone ? item.phone : "Anonymous" }}</span>
            <div class="list" aria-hidden="true" id="commentsMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa-solid fa-ellipsis-v"></i>
            </div>
            <div class="dropdown-menu" aria-labelledby="commentsMenu">
              <button class="dropdown-item" (click)="editCommentSuggestion(item)"><i class="fa-solid fa-edit sub-menu-icon"></i>Edit</button>
              <button class="dropdown-item" (click)="deleteCommentSuggestion(item.id)"><i class="fa-solid fa-trash sub-menu-icon"></i>Delete</button>
            </div>
          </div>
          <div *ngIf="!item.isEdit" class="card-body border-0 p-1 rounded-lg px-2 m-0 mx-1 mb-1 mt-0" style="background-color: #f6f6f6" [innerHTML]="item.text"></div>
          <div class="text-left m-1" *ngIf="item.isEdit">
            <div class="d-flex mt-1">
              <textarea [(ngModel)]="item.commentText" class="form-control mr-1" placeholder="Type your comment..."></textarea>
              <div class="btn-group-vertical mb-auto" *ngIf="!item.hasSubmit">
                <button class="btn btn-primary" (click)="saveCommentSuggestion(item.id, item, true)">
                  <i class="fa-solid fa-save"></i>
                </button>
                <button class="btn btn-danger" (click)="item.isEdit = false">
                  <i class="fa-solid fa-times"></i>
                </button>
              </div>
              <div *ngIf="item.hasSubmit" class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end mb-1">
            <button class="btn btn-primary btn-sm" style="background-color: transparent; color: var(--primary); border: 0" (click)="item.showCommentBox = !item.showCommentBox"><i class="fa-solid fa-add"></i> Add Reply</button>
            <div class="text-left px-1 py-1 pointer" (click)="item.showReply = !item.showReply">
              <i class="fa-solid fa-comment-dots"></i>
              {{ item.replies.length }} Reply
            </div>
          </div>
          <ng-container *ngIf="item.showReply">
            <div class="card text-left p-0 mt-2 rounded-lg mx-1 mb-1" *ngFor="let reply of item.replies">
              <div class="card-header bg-white border-0 p-0 px-1 pt-1 pb-0 mb-0 d-flex justify-content-between">
                <span class="mb-auto">{{ reply.phone ? reply.phone : "Anonymous" }}</span>
                <div class="d-flex" ngbDropdown>
                  <p class="pl-2 my-auto" ngbDropdownToggle>
                    <span class="my-auto pl-2">
                      <i class="fa-solid fa-ellipsis-v"></i>
                    </span>
                  </p>

                  <div ngbDropdownMenu style="width: fit-content; padding: 0 !important" class="FAQmenu">
                    <button ngbDropdownItem class="px-2" (click)="editCommentSuggestion(reply)"><i class="fa-solid fa-edit sub-menu-icon"></i>Edit</button>
                    <button ngbDropdownItem class="px-2" (click)="deleteCommentSuggestion(reply.id)"><i class="fa-solid fa-trash sub-menu-icon"></i>Delete</button>
                  </div>
                </div>
              </div>
              <div *ngIf="!reply.isEdit" class="card-body border-0 p-1 rounded-lg px-2 m-0 mx-1 mb-1 mt-0" style="background-color: #f6f6f6" [innerHTML]="reply.text"></div>
              <div class="text-left m-1" *ngIf="reply.isEdit">
                <div class="d-flex mt-1">
                  <textarea [(ngModel)]="reply.commentText" class="form-control mr-1" placeholder="Type your comment..."></textarea>
                  <div class="btn-group-vertical mb-auto" *ngIf="!reply.hasSubmit">
                    <button class="btn btn-primary" (click)="saveCommentSuggestion(reply.id, reply, true)">
                      <i class="fa-solid fa-save"></i>
                    </button>
                    <button class="btn btn-danger" (click)="reply.isEdit = false">
                      <i class="fa-solid fa-times"></i>
                    </button>
                  </div>
                  <div *ngIf="reply.hasSubmit" class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="alert alert-secondary text-center mx-1" *ngIf="item.replies.length < 1" role="alert"><i
              class="fa-regular fa-comment-alt"></i> There are no replies posted at this time</div> -->
          </ng-container>
          <div class="text-left m-1" *ngIf="item.showCommentBox">
            <div class="d-flex mt-1">
              <textarea [(ngModel)]="item.commentText" class="form-control mr-1" placeholder="Type your comment..."></textarea>
              <div class="btn-group-vertical mb-auto" *ngIf="!item.hasSubmit">
                <button class="btn btn-primary" (click)="saveCommentSuggestion(item.id, item)">
                  <i class="fa-solid fa-save"></i>
                </button>
                <button class="btn btn-danger" (click)="item.showCommentBox = false">
                  <i class="fa-solid fa-times"></i>
                </button>
              </div>
              <div *ngIf="item.hasSubmit" class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="alert alert-secondary text-center" *ngIf="selectedRecommendation.comments.length < 1" role="alert"><i
          class="fa-regular fa-comment-alt"></i> There are no comments posted at this time</div> -->
        <div class="text-left mt-2">
          <!-- <button class="btn btn-primary btn-sm" (click)="selectedRecommendation.showCommentBox = !selectedRecommendation.showCommentBox; selectedRecommendation.commentText = ''"><i class="fa-solid fa-add"></i> Comment</button> -->
          <!-- *ngIf="selectedRecommendation.showCommentBox" -->
          <div class="d-flex mt-1">
            <textarea [(ngModel)]="selectedRecommendation.commentText" class="form-control mr-1" rows="1" placeholder="Type your comment..."></textarea>
            <div class="btn-group-vertical mb-auto" *ngIf="!selectedRecommendation.hasSubmit">
              <button class="btn btn-primary" style="background-color: var(--primary)" (click)="saveCommentSuggestion()">
                <!-- <i class="fa-solid fa-save"></i> -->
                <svg style="width: 1rem; margin: auto; margin-bottom: 0.25rem" viewBox="0 0 668 668" fill="none">
                  <path d="M134 334L34 634L634 334L34 34L134 334ZM134 334H334" stroke="white" stroke-width="66.6667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
              <!-- <button class="btn btn-danger" (click)="selectedRecommendation.showCommentBox = false">
              <i class="fa-solid fa-times"></i>
            </button> -->
            </div>
            <div *ngIf="selectedRecommendation.hasSubmit" class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #suggestionsPopup let-modal>
  <div class="bottom-sheet-suggestions">
    <div class="my-modal__close" (click)="modalRef?.dismiss()">
      <i class="fa-solid fa-times"></i>
      <i class="fa-solid fa-angle-down"></i>
    </div>
    <div class="my-modal__body">
      <h2 class="title">Suggestions</h2>
      <div class="form-group">
        <textarea class="form-control" placeholder="Enter Your Suggestions" id="exampleFormControlTextarea1" maxlength="500" [(ngModel)]="memberMessage" rows="6"></textarea>
      </div>
      <button class="d-flex ml-auto my-button-3" (click)="submitSuggestion()">Submit <i class="fa fa-thumbs-up" aria-hidden="true"></i></button>
    </div>
  </div>
</ng-template>

<ng-template #RecommendProduct let-modal>
  <div class="modal-body">
    <div class="add_cattt">
      <h2>Shout Out</h2>
      <img loading="lazy" src="../../../assets/images/close-icon.svg" alt="img" (click)="modal.dismiss('Cross click')" />
    </div>
    <div class="referral-link">
      <section class="m-4">{{ currentUserNoRecommendation }} experiences left. Are u sure u want to use?</section>
      <div class="mt-4">
        <div class="cart_btn">
          <button class="com_btn add-review-btn px-2" [disabled]="currentUserNoRecommendation == 0" (click)="productRecommendSubmit()">Confirm <i class="fa fa-thumbs-up" aria-hidden="true"></i></button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #recomendationPopup let-modal>
  <div class="bottom-sheet-add-recomendation">
    <div class="my-modal__close" (click)="closeModalByRef()">
      <i class="fa-solid fa-times"></i>
      <i class="fa-solid fa-angle-down"></i>
    </div>
    <div class="my-modal__body">
      <h2 class="title">Experiences</h2>
      <div class="form-group">
        <textarea class="form-control mb-2" placeholder="Enter Your Experiences" id="exampleFormControlTextarea1" maxlength="500" [(ngModel)]="recommendMessage" rows="4"></textarea>
        <!-- accept="image/*,video/*" -->

        <!-- <section class="preview text-center mb-2">
        <img loading="lazy" *ngIf="suggestionBase64" style="max-width: 200px; max-height: 200px" class="map-search-listing-img mt-2 mx-auto img-thumbnail border shadow-sm" [src]="suggestionBase64" alt="" />
      </section>
      <div class="mt-2 text-center">
        <button class="my-button-3 mb-2 mr-2" (click)="uploadRecFile.click()"><i class="fa fa-upload" aria-hidden="true"></i> Upload Picture</button>
        <button *ngIf="roleService.roles?.level?.includes('MEMBER_SHOP_REFERRAL')" class="my-button-3 mb-2 mr-2" (click)="uploadRecVideo.click()"><i class="fa fa-video-camera" aria-hidden="true"></i> Upload Video</button>
        <button *ngIf="roleService.roles?.level?.includes('MEMBER_SHOP_REFERRAL')" class="my-button-3 mb-2 mr-2" (click)="enableYoutubeRecomm()"><i class="fa fa-plus" aria-hidden="true"></i> YOUTUBE EMBED LINK</button>
      </div>
      <input type="file" #uploadRecFile (change)="saveSeletedImage($event)" class="suggestion-modal-pic-input d-none" accept="image/*" />
      <input type="file" #uploadRecVideo (change)="saveSeletedImage($event)" class="suggestion-modal-pic-input d-none" accept="video/mp4,video/x-m4v,video/*" /> -->

        <div class="upload-image" [class.disable]="youtubeLink.length > 0">
          @if(youtubeLink.length === 0) {
          <input #uploadRecFile (change)="saveSelectedFile($event)" type="file" accept="image/*,video/*" />
          }
          <ng-container *ngIf="previewSource">
            <img *ngIf="previewType === 'image'" [src]="previewSource" alt="Thumbnail Preview" />
            <video *ngIf="previewType === 'video'" controls>
              <source [src]="previewSource" type="video/mp4" />
            </video>
          </ng-container>

          <div *ngIf="!previewSource">
            <svg viewBox="0 0 700 662" fill="none">
              <path d="M122.187 122.422C96.5625 148.047 79.1406 179.609 71.25 214.063H84.1406C98.8281 155.234 142.812 107.891 199.766 88.5156V75.3125C170.781 84.375 144.297 100.312 122.187 122.422Z" fill="var(--primary)" />
              <path d="M699.844 353.203C699.844 441.953 627.891 513.984 539.141 514.062H411.563V479.688H539.141C572.891 479.688 604.609 466.484 628.438 442.656C652.344 418.75 665.469 387.031 665.469 353.203C665.469 319.453 652.344 287.656 628.438 263.828C604.531 240 572.734 226.797 538.984 226.797C530 226.797 521.172 227.734 512.578 229.531C500.859 232.031 489.609 236.094 479.141 241.797C478.359 229.766 476.562 217.813 473.828 206.172V206.094C471.016 193.906 467.109 182.031 462.188 170.391C450.938 143.906 434.922 120.078 414.453 99.6094C393.984 79.1406 370.234 63.125 343.672 51.875C316.25 40.3125 287.109 34.375 257.031 34.375C226.953 34.375 197.813 40.2344 170.391 51.875C143.906 63.0469 120.078 79.1406 99.6094 99.6094C79.1406 120.078 63.125 143.906 51.875 170.391C40.2344 197.812 34.375 226.953 34.375 257.031C34.375 287.109 40.2344 316.25 51.875 343.672C63.0469 370.156 79.1406 393.984 99.6094 414.453C120.078 434.922 143.906 450.937 170.391 462.187C197.813 473.75 226.953 479.688 257.031 479.688H288.047V514.062H256.016C114.531 513.516 0 398.672 0 257.031C0 115.078 115.078 0 257.031 0C377.813 0 479.141 83.2813 506.641 195.547V195.625C517.109 193.516 527.891 192.344 538.984 192.344C627.813 192.422 699.844 264.375 699.844 353.203Z" fill="#39393A" />
              <path d="M491.25 427.656H473.594L356.016 310.078V661.328H343.516V310.234L226.016 427.656H208.359L349.766 286.25L491.25 427.656Z" fill="var(--primary)" />
            </svg>
            <div>Please select a image or video to upload. (Optional)</div>
          </div>
        </div>
        <div class="line-or">
          <span>OR</span>
        </div>
        <div class="accordion my-2" id="accordionExample">
          <div class="card">
            <div class="card-header" id="headingOne">
              <div style="display: flex; justify-content: space-between; align-items: center; font-size: 1.15rem" type="button" data-toggle="collapse" data-target="#collapseOne">Add YouTube Embed Link <i class="fa fa-plus"></i></div>
            </div>
            <div id="collapseOne" class="collapse mx-2" aria-labelledby="headingOne" data-parent="#accordionExample">
              <textarea class="form-control my-2" placeholder="Enter Youtube Video URL" id="exampleFormControlTextarea1" maxlength="1000" [(ngModel)]="youtubeLink" rows="2"></textarea>
            </div>
          </div>
        </div>
        @if(uploadProgress > 0) {
        <div class="all-progress" [class.active]="uploadProgress > 0">
          <p>Uploading... {{ uploadProgress }}%</p>
          <div class="progress">
            <div class="progress-bar" role="progressbar" [style.width.%]="uploadProgress"></div>
          </div>
        </div>
        }

        <!-- <section class="preview text-center mb-2">
        <img *ngIf="previewType === 'image'" loading="lazy" style="max-width: 200px; max-height: 200px" class="map-search-listing-img mt-2 mx-auto img-thumbnail border shadow-sm" [src]="previewSource" alt="Image Preview" />
        <video *ngIf="previewType === 'video'" style="max-width: 200px; max-height: 200px" class="mt-2 mx-auto border shadow-sm" controls>
          <source [src]="previewSource" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </section>

      <div class="mt-2 text-center">
        <button class="my-button-3 mb-2 mr-2" (click)="uploadRecFile.click()"><i class="fa fa-upload" aria-hidden="true"></i> Upload Picture or Video</button>
      </div>
      <input type="file" #uploadRecFile (change)="saveSelectedFile($event)" class="suggestion-modal-pic-input d-none" accept="image/*,video/*" /> -->
      </div>
      <div class="mt-2">
        <div class="cart_btn d-flex" style="gap: 10px">
          <button [disabled]="uploadProgress > 0" class="com_btn add-review-btn px-2 btn-pupple mb-0" (click)="submitRecommendation()">Experience <i class="fa fa-thumbs-up" aria-hidden="true"></i></button>

          <!-- <button *ngIf="roleService.roles?.level?.includes('MEMBER_SHOP_REFERRAL')" class="com_btn add-review-btn px-2 mb-0" style="background-color: gold" (click)="recommendProduct(productData, RecommendProduct)">SUPPORT SELLER <i class="fa fa-bullhorn" aria-hidden="true"></i></button> -->
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #reportsPopup let-modal>
  <div class="bottom-sheet-reports">
    <div class="my-modal__close" (click)="modalRef?.dismiss()">
      <i class="fa-solid fa-times"></i>
      <i class="fa-solid fa-angle-down"></i>
    </div>
    <div class="my-modal__body">
      <h2 class="title">Report</h2>
      <div class="mt-2 mb-1" style="color: var(--primary)">Report Something Suspicious :</div>

      <div class="form-group">
        <label for="">Report Type</label>
        <select [(ngMode;)]="reportType" id="" class="form-control">
          <option value="Spam">Spam</option>
          <option value="Wrong Info">Wrong Info</option>
          <option value="Repeated">Repeated</option>
          <option value="Out of business">Out of business</option>
          <option value="Offensive language">Offensive language</option>
          <option value="Offensive image">Offensive image</option>
        </select>
      </div>
      <div class="form-group">
        <textarea class="form-control" placeholder="Enter details" id="exampleFormControlTextarea1" maxlength="500" [(ngModel)]="memberMessage" rows="6"></textarea>
      </div>
      <button class="d-flex ml-auto my-button-3" (click)="submitReport()">Submit <i class="fa fa-gavel" aria-hidden="true"></i></button>
    </div>
  </div>
</ng-template>
